import React from 'react';
import styled from 'styled-components';


import {ReactComponent as BackgroundImagesLeft} from './../assets/img/background_left_up.svg';
import {ReactComponent as BackgroundImagesRight} from './../assets/img/background_rigth_bottom.svg';

const Svg = styled.svg`
 height: 50vh;
 width: 100%;
 position: fixed;
 bottom: 0;
 z-index: 0;
 path {
    fill: rgba(255 217 0 / 0.49);
 }
`;

const BackgroundImagesLefts = styled(BackgroundImagesLeft) `
    position: fixed;
    z-index: 1;
    top: 2.5rem;
    left: 0;
`;

const BackgroundImagesRights = styled(BackgroundImagesRight) `
    position: fixed;
    z-index: 1;
    bottom: 2.5rem;
    right: 0;
`;


const Background = () => {
    return ( 
        <>
            <BackgroundImagesLefts/>
            <Svg xmlns="http://www.w3.org/2000/svg" 
            viewBox="0 0 1440 320" preserveAspectRatio='none'>
                <path fill="#ffd700" 
                fillOpacity="1" 
                d="M0,160L34.3,149.3C68.6,139,137,117,206,106.7C274.3,96,343,96,411,101.3C480,107,549,117,617,144C685.7,171,754,213,823,229.3C891.4,245,960,235,1029,218.7C1097.1,203,1166,181,1234,154.7C1302.9,128,1371,96,1406,80L1440,64L1440,320L1405.7,320C1371.4,320,1303,320,1234,320C1165.7,320,1097,320,1029,320C960,320,891,320,823,320C754.3,320,686,320,617,320C548.6,320,480,320,411,320C342.9,320,274,320,206,320C137.1,320,69,320,34,320L0,320Z">
                    </path>
                    </Svg>
            <BackgroundImagesRights/>
        </>
     );
}
 
export default Background;